import { render, staticRenderFns } from "./a.vue?vue&type=template&id=a8c65d86&scoped=true"
import script from "./a.vue?vue&type=script&lang=js"
export * from "./a.vue?vue&type=script&lang=js"
import style0 from "./a.vue?vue&type=style&index=0&id=a8c65d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c65d86",
  null
  
)

export default component.exports